// ============================================================================
// layer.dailys.detail — the layer daily record page, off App's boot arrays
// ============================================================================
// The record read was already page-local; `layer.daily.detail` keeps its exact
// projection, its eq(id) shape and its deleted_at filter, so a soft-deleted
// report still resolves to not-found rather than to a row. What actually
// changed here is the second obligation: the group dropdown's three arrays used
// to arrive as a LayerEntry prop carrying App's former-eager boot results.
//
// This surface migrated in the SAME change as its index sibling, not because
// its own read demanded it, but because layer.dailys.groupDirectory is read in
// LayerDailysRouter above the index/record branch and a catalog resource may
// only name surfaces the manifest declares migrated. Migrating the hub alone
// would have left this page consuming a permanent resource it did not own.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'layer.dailys.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'layer.daily.detail', owner: 'permanent'}),
    Object.freeze({id: 'layer.dailys.groupDirectory', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
